import { cloneDeep, get } from 'lodash';
import isEmpty from 'lodash/isEmpty';

import { IEventBreakdown, ILandingEvent } from '@src/emp-3.0/types';

import { isValidFilter, trimEventFilter } from '.';

interface IUpdateEventNameFiltersByLandingEvent {
  landing_events: ILandingEvent[];
  event_name_filters: string[];
}
export const updateEventNameFiltersByLandingEvent = ({
  landing_events = [],
  event_name_filters = [],
}: IUpdateEventNameFiltersByLandingEvent): string[] => {
  const newEventNameSet = new Set(event_name_filters);
  landing_events.forEach((item) => {
    if (item.event_name && !newEventNameSet.has(item.event_name)) {
      newEventNameSet.add(item.event_name);
    }
  });
  return Array.from(newEventNameSet);
};

interface IUpdateEventBreakdownByLandingEvent {
  event_breakdown: IEventBreakdown[];
  landing_event: ILandingEvent;
}
export const updateEventBreakdownByLandingEvent = ({
  event_breakdown = [],
  landing_event,
}: IUpdateEventBreakdownByLandingEvent): IEventBreakdown[] => {
  // Prevent duplicate reference
  const copyEventData = cloneDeep(landing_event);
  const copyEventBreakdown = cloneDeep(event_breakdown);

  const landingEventName = copyEventData.event_name;
  const landingEventFilters = copyEventData.filters;
  const trimLandingEventFilters = trimEventFilter(landingEventFilters);
  const isLandingEventWithValidFilters = isValidFilter(trimLandingEventFilters);

  const newBreakdownItem = {
    event_name: landingEventName,
    breakdowns: landingEventFilters.map((item) => {
      const value = get(item, '[0].value');
      if (!isEmpty(value)) {
        return [
          {
            ...item[0],
            is_all: true,
            value: [],
          },
        ];
      }
      return item;
    }),
  };
  const isEventInBreakdown = copyEventBreakdown.some(
    (item) => item.event_name === landingEventName,
  );
  if (isEventInBreakdown && isLandingEventWithValidFilters) {
    for (let i = 0; i < copyEventBreakdown.length; i++) {
      if (copyEventBreakdown[i].event_name === landingEventName) {
        copyEventBreakdown[i] = newBreakdownItem;
        break;
      }
    }
  } else {
    copyEventBreakdown.unshift(newBreakdownItem);
  }
  return copyEventBreakdown;
};

export function addDefaultToEventBreakdown({
  event_breakdown = [],
  landing_event,
}: IUpdateEventBreakdownByLandingEvent): IEventBreakdown[] {
  // Default value if event_breakdown is null or empty
  if (!event_breakdown?.length) {
    return [{ event_name: '', breakdowns: [] }];
  }

  // Check if event_breakdown has one item and matches landing_events[0].event_name
  if (event_breakdown.length === 1 && event_breakdown[0].event_name === landing_event?.event_name) {
    // Append a new default event_breakdown
    return [...event_breakdown, { event_name: '', breakdowns: [] }];
  }

  // Otherwise, return event_breakdown as is
  return event_breakdown;
}
